export class CrmService {
	constructor(CoreApi) {
		this.CoreApi = CoreApi;
	}
	list(params) {
		return this.CoreApi.makeApiCall("POST", "crm/list/", params).then(r => r.data);
	}
	get(id) {
		return this.CoreApi.makeApiCall("POST", "crm/get/", {id}).then(r => r.data);
	}
	getIframe(data) {
		return this.CoreApi.makeApiCall("GET", "crm/connect/getIframe/", data).then(r => r.data);
	}
	checkCustomerRegistration() {
		return this.CoreApi.makeApiCall("GET", "crm/isRegister/").then(r => r.data);
	}
	delete(id) {
		return this.CoreApi.makeApiCall("POST", "crm/delete/", {id}).then(r => r);
	}
	create(data) {
		return this.CoreApi.makeApiCall("POST", "crm/create/", data).then(r => r);
	}
}
